import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
// import DuckImage from '../assets/Duck.jpg'
import $ from 'jquery';
import swal from 'sweetalert';
import { getErrorMessage } from '../../../../components/CommonFunction';

    const cellColor = {
        Reserved: '#2BDEFB',
        Confirmed: '#2196F3',
        Forecasted: '#ccc',
        Blocked: '#888',
    };

$.fn.highlight = () => {
    $(this).each(() => {
        const el = $(this);
        $('<div/>')
            .width(el.outerWidth())
            .height(el.outerHeight())
            .css({
                position: 'absolute',
                left: el.offset().left,
                top: el.offset().top,
                backgroundColor: '#ffff99',
                opacity: '.8',
                zIndex: '9999999',
            })
            .appendTo('body')
            .fadeOut(2000)
            .queue(() => { $(this).remove(); });
    });
};

class Cell extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.visitModalView = this.visitModalView.bind(this);
    }

    componentDidMount() {
    }

    arrowRight(e) {
        const nextId = `#${$(e.target).parent()[0].value}`;

        if ($(nextId).length == 0) {
            const errorMessage = getErrorMessage('AMA:NO_NEXT_SEGMENT');
            swal({
                title: 'No Segment',
                text: `${errorMessage.Error_Message__c}<br /> ${errorMessage.Instruction__c}`,
                type: 'info',
                confirmButtonText: 'Close',
            });
            return;
        }

        $('body').scrollTop($(nextId).offset().top - 100);
        $('.table-responsive').scrollLeft($(nextId).offset().left - 200);
        const thisCol = $(nextId).closest('tr').children().index($(e.target.closest('td')));
        $(nextId).closest('td').highlight();
    }

    arrowLeft(e) {
        const prevId = `#${$(e.target).parent()[0].value}`;

        if ($(prevId).length == 0) {
            const errorMessage = getErrorMessage('AMA:NO_PREV_SEGMENT');
            swal({
                title: 'No Segment ',
                text: `${errorMessage.Error_Message__c}\n${errorMessage.Instruction__c}`,
                type: 'info',
                confirmButtonText: 'Close',
            });
            return;
        }
        $('body').scrollTop($(prevId).offset().top - 100);
        $('.table-responsive').scrollLeft($(prevId).offset().left - 200);
        const thisCol = $(prevId).closest('tr').children().index($(e.target.closest('td')));
        $(prevId).closest('td').highlight();
    }

    visitModalView() {
        if (this.props.data.Id) {
            const previousCellId = `${this.props.selectedCellId}`; // Creates a new string
            const newCellId = `${this.props.data.Id}`;
            const previousStatus = `${this.props.previousCellStatus}`


            if (previousCellId && previousCellId !== newCellId) {
                setTimeout(() => {
                    $(`.${previousCellId}`).css({
                        backgroundColor: cellColor[previousStatus] || '#fff',
                        color: '#222',
                    });
                }, 0);
            }
            
            this.props.setSelectedCellId(newCellId);
            this.props.setPreviousCellStatus(this.props.data.Allocation_Status__c);

            setTimeout(() => {
                $(`.${newCellId}`).css({
                    backgroundColor: '#f39c12',
                    color: '#fff',
                });
            }, 0);
            setTimeout(() => {
                $(`.${newCellId}`).css({
                    backgroundColor: cellColor[this.props.data.Allocation_Status__c] || '#fff',
                    color: '#222',
                });
                this.props.setSelectedCellId(null);
                this.props.setPreviousCellStatus(null);
            }, 5000);
            this.props.showDetail(true, this.props.data);
        }
    }


    render() {
        const { props } = this;

        

        const genderIcon = {
            male: 'mars',
            female: 'venus',
            undefined: 'genderless',
            '': 'genderless',
        };

        if (props.data === undefined) {
            return (<td
                colSpan={props.colSpan}
                className="cell text-center"
                style={{ backgroundColor: '#fff' }}
            />);
        }

        const Icons = [];
        const tdStyle = { backgroundColor: cellColor[props.data.Allocation_Status__c], height: 20 };
        let additionalClass = '';
        props.data.Segments = props.data.Segments ? props.data.Segments : [];
        if (props.data.Sharing_Type__c === 'Share w/person (Unknown)' || props.data.Sharing_Type__c === 'Sharing Unknown') {
            tdStyle.border = '2px solid #800080';
            additionalClass = 'increased';
        } else if (props.data.Overbooking__c === true) {
            tdStyle.boxShadow = '2px solid red';
            additionalClass = 'increased';
        }
        Icons.push(<div>
            <div className="col-sm-3" />
            <div className="col-sm-6 text-center" style={{ height: 15 }}>
                {
                    props.data.Segments.map((obj) => {
                        if (obj.Start_Date__c <= props.currentDate && obj.End_Date__c > props.currentDate ) {
                            let { GenderF__c: gender } = obj;
                            gender = gender ? gender.toLowerCase() : obj.Gender__c;
                            const selectedIcon = genderIcon[gender] || 'genderless';
                            return <i className={`fa fa-${selectedIcon}`} />;
                        }
                    })}
            </div>
            <div className="col-sm-3" />
        </div>);    

        return (
            <td
                colSpan={props.colSpan}
                className={`${props.data.Id} cell text-center ${additionalClass} ${props.rowNumber}`}
                style={tdStyle}
                onClick={this.visitModalView}
                onKeyDown={() => null}
                
                cellSpacing={2}
                onMouseOver={() => {
                    if (props.data.Id === undefined) return;
                    $(`.${props.data.Id}`).css({
                        backgroundColor: '#222',
                        color: '#fff',
                    });
                }}
                onMouseOut={() => {
                    if (props.data.Id === undefined) return;
                    $(`.${props.data.Id}`).css({
                        backgroundColor: cellColor[props.data.Allocation_Status__c],
                        color: '#222',
                    });
                }}
                onFocus={e => e}
                onBlur={e => e}
            >
                
                {Icons}
                <div className="clearfix" />
            </td>
        );
    }
}


const Icon = (props) => {
    const icons = [];
    if (props.share === true) {
        icons.push(<i
            className={`text-left cell-icon fa fa-${props.type}`}
            key={Math.random()}
        />);
        icons.push(<div style={{ height: 5 }} />);
        icons.push(<i
            className={`fa cell-icon fa-${props.type}`}
            key={Math.random()}
        />);
    } else {
        icons.push(<i className={`text-left cell-icon fa fa-${props.type}`} key={props.type + 1} />);
    }
    return <span className="">{icons}</span>;
};

Icon.propTypes = {
    type: PropTypes.string.isRequired,
    share: PropTypes.bool.isRequired,
};

Cell.propTypes = {
    // cellColor: PropTypes.string,
    // isEmpty: PropTypes.bool,
    // additionalClass: PropTypes.string,
    // iteration: PropTypes.number.isRequired,
    data: PropTypes.object,
    showDetail: PropTypes.func.isRequired,
    next: PropTypes.func,
};

Cell.defaultProps = {
    data: {},
};

export default Cell;
